var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "f180d1bf1d857cae060f2353bf46d1e3530a2e82"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["www-ligonier-org@ligonier"] = {
  id: "f180d1bf1d857cae060f2353bf46d1e3530a2e82"
};